__turbopack_context__.v({
  "className": "caveat_9745fdba-module__d88X3W__className",
});
